module.exports = __webpack_public_path__ + "img/SEJ_Eventos_asistentes_black.5abede6a.svg";